import Gun from 'gun';

export const instantiateGun = () => {
  return Gun({
    peers: ['https://fileverse-gun-server.herokuapp.com/gun'],
  });
};
